import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { convertJsonToFormData, mapFormData } from 'helpers/formData';

export interface ClientDashboardLinkReorderPatchOptions {
  position: number;
}

export function clientDashboardLinkReorderApi(path: string) {
  return {
    path,
    PATCH: (params: ClientDashboardLinkReorderPatchOptions) =>
      api.patch<JsonApiResponse>(
        path,
        convertJsonToFormData({
          data: {
            attributes: mapFormData(params),
          },
        })
      ),
  };
}
